// API Configuration
export const API_BASE_URL = 'https://buildersupply-backend-444110546582.asia-south1.run.app';
export const API_URL = `${API_BASE_URL}/api`;

// Google Maps JavaScript API key for the admin live-tracking map.
//
// SECURITY NOTE: this is a *browser* key. CRA inlines REACT_APP_* values into
// the JS bundle at build time, so the key is always visible to anyone who opens
// the site — moving it to an env var does NOT make it secret. Real protection
// comes from restricting the key in Google Cloud Console:
//   1. Application restriction → HTTP referrers → https://www.wheelkart.co.in/*
//      (plus localhost for dev).
//   2. API restriction → "Maps JavaScript API" only.
// The env var just keeps the value out of committed source and lets us swap a
// dedicated web key without a code change. If absent/invalid, the tracking map
// falls back to the OpenStreetMap (Leaflet) view automatically.
export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';

// Media URLs
export const getImageUrl = (path: any): string => {
  if (!path) return '';
  
  // Handle the case where path might be an object with a url property
  if (typeof path === 'object' && path !== null && 'url' in path) {
    return getImageUrl(path.url);
  }
  
  // Convert to string to ensure we can use string methods
  const pathStr = String(path);
  
  // Check if it's already an absolute URL
  if (pathStr.startsWith('http')) return pathStr;
  
  // Make sure the path starts with a slash
  const formattedPath = pathStr.startsWith('/') ? pathStr : `/${pathStr}`;
  return `${API_BASE_URL}${formattedPath}`;
}; 